import { string, object, ref } from 'yup';

export default object().shape({
    password:
        string()
            .required('REQUIRED')
            .matches(/^(?=.*[A-Z])(?=.*[!#$&*@])(?=.*\d)(?=.*[a-z]).{8,20}/, 'VALID_PASSWORD'),
    repeatedPassword:
        string()
            .required('REQUIRED')
            .oneOf([ref('password')], 'MATCH_PASSWORD')
});
